import { render, staticRenderFns } from "./foodType.vue?vue&type=template&id=52da64c0&"
import script from "./foodType.vue?vue&type=script&lang=js&"
export * from "./foodType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports